import React from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoFullWhite from '../../assets/images/logo-full-white.png';
import gjepc from '../../assets/images/footer/gjepc.png';
import rapnet from '../../assets/images/footer/rapnet.png';
import giaSmall from '../../assets/images/footer/gia-small.svg';
import igaSmall from '../../assets/images/footer/iga-small.svg';
import hrdSmall from '../../assets/images/footer/hrd-small.png';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <Container>
        <Row className="gy-5 top-row align-items-start footer-main-row">
          {/* 1. Branding */}
          <Col xs={12} md={3} className="footer-brand-col">
            <div className="brand-block">
              <img src={logoFullWhite} alt="SunDiam" className="footer-logo-full" />
              <p className="tagline">The Art of Diamond Precision</p>
              <div className="rating" aria-label="5 star rating">
                {Array.from({ length: 5 }).map((_, i) => <i key={i} className="fas fa-star" />)}
              </div>
            </div>
          </Col>
          {/* 2. Links group (3 internal columns) */}
          <Col xs={12} md={4} className="footer-links-group">
            <div className="links-sub-col">
              <h5 className="col-title">Company</h5>
              <ul className="col-links">
                <li><Link to="/leadership">Leaderships</Link></li>
                <li><Link to="/diamonds">Diamonds</Link></li>
                {/* <li><a href="#events">Events & News</a></li>
                <li><a href="#blogs">Blogs</a></li> */}
              </ul>
            </div>
            <div className="links-sub-col">
              <h5 className="col-title">Quick Links</h5>
              <ul className="col-links">
                <li><a href="/login">Registration</a></li>
                <li><Link to="/certifications">Certifications</Link></li>
                <li><Link to="/grading">Grading System</Link></li>
              </ul>
            </div>
            <div className="links-sub-col">
              <h5 className="col-title">Legal</h5>
              <ul className="col-links">
                <li><a href="/certifications#gia-certification">GIA Certification</a></li>
                <li><a href="/certifications#igi-certification">IGI Certification</a></li>
                <li><a href="/certifications#hrd-certification">HRD Certification</a></li>
                <li><Link to="/business-principles">Business Principles</Link></li>
                <li><Link to="/terms">Terms &amp; Conditions</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
          </Col>
          {/* 3. Member of */}
          <Col xs={6} md={2} className="footer-member-col">
            <h5 className="col-title member-title">Member of:</h5>
            <div className="member-logos" aria-label="Membership logos">
              <img src={rapnet} alt="Rapnet" />
              <img src={gjepc} alt="GJEPC" />
            </div>
          </Col>
          {/* 4. Contact + Trusted by logos */}
            <Col xs={12} md={3} className="footer-contact-col">
              <div className="trusted-block" aria-label="Trusted by logos">
                <h5 className="col-title trusted-title">Trusted by:</h5>
                <div className="trusted-logos">
                  <img src={giaSmall} alt="GIA" />
                  <img src={igaSmall} alt="IGA" />
                  <img src={hrdSmall} alt="HRD" />
                </div>
              </div>
              <div className="contact-inline" aria-label="Contact information and subscription form">
                <div className="contact-item phone"><i className="fas fa-phone" /> <a href="tel:+919920663357">+91 9920663357</a></div>
                <div className="contact-item email"><i className="fas fa-envelope" /> <a href="mailto:sales.sundiam2013@gmail.com">sales.sundiam2013@gmail.com</a></div>
                <Form className="subscribe-form" onSubmit={e => e.preventDefault()}>
                  <div className="subscribe-wrapper">
                    <Form.Control type="email" placeholder="Your Email…" aria-label="Your Email" required />
                    <button type="submit" className="subscribe-btn"><span>Get in Touch</span></button>
                  </div>
                </Form>
              </div>
            </Col>
        </Row>
        <hr className="footer-sep" />
        <Row className="bottom-row align-items-center">
          <Col md={7} className="copy-col">
            <p className="copyright">Copyright © {year} SunDiam. All rights reserved</p>
          </Col>
            <Col md={5} className="social-col">
              <ul className="social-list">
                <li><a href="https://wa.me/919920663357" aria-label="WhatsApp"><i className="fab fa-whatsapp" /></a></li>
                <li><a href="https://www.instagram.com/sun.diam/" aria-label="Instagram"><i className="fab fa-instagram" /></a></li>
                <li><a href="https://www.facebook.com/share/1AH2KWpZfH/" aria-label="Facebook"><i className="fab fa-facebook-f" /></a></li>
                <li><a href="https://www.linkedin.com/in/sundiam9999/" aria-label="LinkedIn"><i className="fab fa-linkedin-in" /></a></li>
                <li><a href="https://x.com/sundiam2013" aria-label="X / Twitter"><i className="fab fa-x-twitter" /></a></li>
              </ul>
            </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
